export const getTextHeight = (elem) => {
  if (document.createRange) {
    var range = document.createRange();
    range.selectNodeContents(elem);
    if (range.getBoundingClientRect) {
      var rect = range.getBoundingClientRect();
      if (rect) {
        return rect.bottom - rect.top;
      }
    }
  } else {
    return null;
  }
};

export const getDeclination = (value, words) => {
  value = Math.abs(value) % 100;
  var num = value % 10;
  if (value > 10 && value < 20) return words[2];
  if (num > 1 && num < 5) return words[1];
  if (num == 1) return words[0];
  return words[2];
};

export const stringPriceToNumber = (price) => {
  if (typeof price == "string") {
    price = price.replace(",", ".").replace(" ", "");
    return +price;
  } else {
    return price;
  }
};

export const formatPrice = (price) => {
  if (!price) return;

  const addZeroes = (x) => {
    return x.toLocaleString("en", {
      useGrouping: false,
      minimumFractionDigits: 2,
    });
  };

  const numberWithSpaces = (x) => {
    var parts = x.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    return parts.join(".");
  };

  if (typeof price === "string" && price.indexOf(",") === -1) {
    price = +price;
  }

  price = addZeroes(price);

  return numberWithSpaces(price.replace(".", ","));
};

export const preparePattern = (validation) => {
  Object.keys(validation || {}).forEach((key) => {
    if (key === "pattern") {
      validation[key]["value"] = new RegExp(validation[key]["value"]);
    }
  });
};

export const computedClass = (props) => {
  return Object.entries(props).reduce((acc, [prop, value]) => (acc += value ? prop + ' ' : ''), '')
}


export const formatSeconds = (seconds) =>new Date(seconds * 1000).toISOString().substring(14, 19);